angular.module('mtic.components.alert_popup', [])
.directive('alertPopup', function (
      $interval,
      $timeout,
      TIMING_CONSTANTS
) {
      return {
            templateUrl: 'template.html',
            transclude: false,
            scope: {
                  text: '=',
                  type: '@',
                  timeout: '=?'
            },
            link: function (scope) {
                  var lastInterval = null;

                  function activateAlert() {
                        if (!scope.text) {
                              scope.show = false;
                              return;
                        }

                        if (lastInterval) {
                              $timeout.cancel(lastInterval);
                        }
                        scope.show = true;
                        lastInterval = $timeout(
                              function () {
                                    scope.show = false;
                                    scope.text = null;
                              },
                              scope.timeout || TIMING_CONSTANTS.ALERT_BOX_DEFAULT_DISPLAY_MS
                        );
                  }
                  activateAlert();
                  scope.$watch('text', activateAlert);
            }
      }
})
